export const demoSongs = [
  {
    title: "Huhtikuu",
    artist: "Egotrippi",
    year: 2000,
    mood: ["rauhallinen", "suomipop", "tunnelmallinen"],
  },
  {
    title: "Lautalla",
    artist: "Kolmas nainen",
    year: 1990,
    mood: ["suomirock", "nostalginen", "yhteislaulu"],
  },
  {
    title: "Äiti pojastaan pappia toivoi",
    artist: "Irwin Goodman",
    year: 1970,
    mood: ["klassikko", "huumori", "yhteislaulu"],
  },
  {
    title: "Ukkometso",
    artist: "Popeda",
    year: 1980,
    mood: ["rock", "bileet", "suomirock"],
  },
  {
    title: "Sankarit",
    artist: "J. Karjalainen",
    year: 1990,
    mood: ["klassikko", "yhteislaulu", "suomipop"],
  },
  {
    title: "Rakkaus on lumivalkoinen",
    artist: "Yö",
    year: 2000,
    mood: ["hidas", "tunteikas", "häät"],
  },
  {
    title: "Mitä tänne jää",
    artist: "J. Karjalainen",
    year: 1990,
    mood: ["tunnelmallinen", "suomipop", "ilta"],
  },
  {
    title: "Mä olen tässä",
    artist: "Samuli Putro",
    year: 2010,
    mood: ["tunteikas", "suomipop", "rauhallinen"],
  },
  {
    title: "Paratiisi",
    artist: "Rauli Badding Somerjoki",
    year: 1970,
    mood: ["klassikko", "tunteikas", "nostalginen"],
  },
  {
    title: "Ikkunaprinsessa",
    artist: "Rauli Badding Somerjoki",
    year: 1970,
    mood: ["klassikko", "suomi-iskelmä", "yhteislaulu"],
  },
  {
    title: "Moottoritie on kuuma",
    artist: "Pelle Miljoona",
    year: 1980,
    mood: ["suomirock", "bileet", "klassikko"],
  },
  {
    title: "Joutsenlaulu",
    artist: "Yö",
    year: 1980,
    mood: ["hidas", "klassikko", "tunteikas"],
  },
  {
    title: "Ihmisten edessä",
    artist: "Jenni Vartiainen",
    year: 2000,
    mood: ["pop", "tunteikas", "häät"],
  },
  {
    title: "Missä muruseni on",
    artist: "Jenni Vartiainen",
    year: 2010,
    mood: ["hidas", "tunteikas", "suomipop"],
  },
  {
    title: "Hetki lyö",
    artist: "Kirka",
    year: 1970,
    mood: ["klassikko", "bileet", "yhteislaulu"],
  },
  {
    title: "Leijat",
    artist: "Kirka",
    year: 1960,
    mood: ["klassikko", "nostalginen", "iskelmä"],
  },
  {
    title: "Surun pyyhit silmistäni",
    artist: "Kirka",
    year: 1980,
    mood: ["hidas", "tunteikas", "klassikko"],
  },
  {
    title: "Aikuinen nainen",
    artist: "Paula Koivuniemi",
    year: 1980,
    mood: ["iskelmä", "yhteislaulu", "klassikko"],
  },
  {
    title: "Sata kesää, tuhat yötä",
    artist: "Paula Koivuniemi",
    year: 1980,
    mood: ["iskelmä", "bileet", "yhteislaulu"],
  },
  {
    title: "Kolmatta linjaa takaisin",
    artist: "Fredi",
    year: 1960,
    mood: ["klassikko", "nostalginen", "yhteislaulu"],
  },
  {
    title: "Hopeinen kuu",
    artist: "Olavi Virta",
    year: 1960,
    mood: ["tango", "klassikko", "nostalginen"],
  },
  {
    title: "Satumaa",
    artist: "Reijo Taipale",
    year: 1960,
    mood: ["tango", "klassikko", "hidas"],
  },
  {
    title: "Lapin kesä",
    artist: "Vesa-Matti Loiri",
    year: 1980,
    mood: ["tunteikas", "klassikko", "rauhallinen"],
  },
  {
    title: "Nocturne",
    artist: "Vesa-Matti Loiri",
    year: 1970,
    mood: ["rauhallinen", "tunteikas", "klassikko"],
  },
  {
    title: "Tinakenkätyttö",
    artist: "Kaija Koo",
    year: 1990,
    mood: ["suomipop", "yhteislaulu", "nostalginen"],
  },
  {
    title: "Kuka keksi rakkauden",
    artist: "Kaija Koo",
    year: 1990,
    mood: ["suomipop", "tunteikas", "klassikko"],
  },
  {
    title: "Levoton tuhkimo",
    artist: "Dingo",
    year: 1980,
    mood: ["suomirock", "nostalginen", "bileet"],
  },
  {
    title: "Autiotalo",
    artist: "Dingo",
    year: 1980,
    mood: ["suomirock", "klassikko", "yhteislaulu"],
  },
  {
    title: "Kaksoiselämää",
    artist: "Juice Leskinen",
    year: 1980,
    mood: ["suomirock", "klassikko", "yhteislaulu"],
  },
  {
    title: "Syksyn sävel",
    artist: "Juice Leskinen",
    year: 1970,
    mood: ["klassikko", "suomirock", "nostalginen"],
  },
  {
    title: "Mies, jolle ei koskaan tapahdu mitään",
    artist: "Juice Leskinen",
    year: 1980,
    mood: ["suomirock", "tarinallinen", "klassikko"],
  },
  {
    title: "Villejä lupiineja",
    artist: "Kari Tapio",
    year: 1990,
    mood: ["iskelmä", "tunteikas", "klassikko"],
  },
  {
    title: "Olen suomalainen",
    artist: "Kari Tapio",
    year: 1980,
    mood: ["iskelmä", "klassikko", "yhteislaulu"],
  },
  {
    title: "Myrskyn jälkeen",
    artist: "Kari Tapio",
    year: 1990,
    mood: ["tunteikas", "iskelmä", "hidas"],
  },
  {
    title: "Valot",
    artist: "Ville Valo & Agents",
    year: 2010,
    mood: ["tunnelmallinen", "nostalginen", "suomipop"],
  },
  {
    title: "Pieni ja hento ote",
    artist: "Dave Lindholm",
    year: 1980,
    mood: ["akustinen", "klassikko", "rauhallinen"],
  },
  {
    title: "Sitähän se kaikki on",
    artist: "Tehosekoitin",
    year: 2000,
    mood: ["suomirock", "nostalginen", "bileet"],
  },
  {
    title: "Hetken tie on kevyt",
    artist: "Tehosekoitin",
    year: 2000,
    mood: ["tunteikas", "suomirock", "häät"],
  },
  {
    title: "Tytöt tahtoo pitää hauskaa",
    artist: "Katri Helena",
    year: 1980,
    mood: ["bileet", "iskelmä", "yhteislaulu"],
  },
  {
    title: "Katson sineen taivaan",
    artist: "Katri Helena",
    year: 1970,
    mood: ["iskelmä", "klassikko", "nostalginen"],
  },
  {
    title: "Sweet Caroline",
    artist: "Neil Diamond",
    year: 1969,
    mood: ["yhteislaulu", "bileet", "klassikko"],
  },
  {
    title: "Wonderwall",
    artist: "Oasis",
    year: 1995,
    mood: ["akustinen", "yhteislaulu", "90-luku"],
  },
  {
    title: "Have You Ever Seen the Rain",
    artist: "Creedence Clearwater Revival",
    year: 1971,
    mood: ["klassikko", "akustinen", "nostalginen"],
  },
  {
    title: "Knockin' on Heaven's Door",
    artist: "Bob Dylan",
    year: 1973,
    mood: ["akustinen", "klassikko", "rauhallinen"],
  },
  {
    title: "Ring of Fire",
    artist: "Johnny Cash",
    year: 1963,
    mood: ["country", "klassikko", "nostalginen"],
  },
  {
    title: "Stand by Me",
    artist: "Ben E. King",
    year: 1961,
    mood: ["häät", "klassikko", "tunteikas"],
  },
  {
    title: "Hallelujah",
    artist: "Leonard Cohen",
    year: 1980,
    mood: ["hidas", "tunteikas", "akustinen"],
  },
  {
    title: "Let It Be",
    artist: "The Beatles",
    year: 1970,
    mood: ["klassikko", "rauhallinen", "yhteislaulu"],
  },
  {
    title: "Hey Jude",
    artist: "The Beatles",
    year: 1968,
    mood: ["klassikko", "yhteislaulu", "bileet"],
  },
  {
    title: "Hotel California",
    artist: "Eagles",
    year: 1977,
    mood: ["klassikko", "rock", "akustinen"],
  },
  {
    title: "Proud Mary",
    artist: "Creedence Clearwater Revival",
    year: 1969,
    mood: ["bileet", "rock", "klassikko"],
  },
  {
    title: "Bad Moon Rising",
    artist: "Creedence Clearwater Revival",
    year: 1969,
    mood: ["rock", "nostalginen", "bileet"],
  },
  {
    title: "Country Roads",
    artist: "John Denver",
    year: 1971,
    mood: ["country", "yhteislaulu", "klassikko"],
  },
  {
    title: "I’m Yours",
    artist: "Jason Mraz",
    year: 2000,
    mood: ["akustinen", "kesä", "rentoutunut"],
  },
];

export const quickSearches = [
  "häät",
  "bileet",
  "rauhallinen",
  "yhteislaulu",
  "suomirock",
  "iskelmä",
  "tango",
  "90-luku",
  "1980",
  "1970",
  "akustinen",
  "klassikko",
];


